import {Injectable} from "@angular/core";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {firstValueFrom, Observable} from "rxjs";
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class RoleAuthService {
  constructor( private _oidcSecurityService: OidcSecurityService ) {}

  async isAuthenticatedPromise(): Promise<boolean> {
    return await firstValueFrom(this.isAuthenticated());
  }

  async userHasRoleOnTokenAsPromise(authorizedRoles: string[]): Promise<boolean> {
    return await firstValueFrom(this.userHasRoleOnToken(authorizedRoles));
  }

  isAuthenticated(): Observable<boolean> {
    // We are looking at isAuthenticated because we only need to know if the user has been authenticated for the purpose of API calls.
    //
    // Note: At this point, we do not care if the IdentityToken is expired as it is only used at initial login and valid for a few minutes.
    // The AccessToken will be silent renewed automatically after the initial IdentityToken is verified with CheckAuth().
    return this._oidcSecurityService.isAuthenticated();
  }

  userHasRoleOnToken(authorizedRoles: string[]): Observable<boolean> {
    return this._oidcSecurityService.getPayloadFromIdToken().pipe(map(token => {
      let authorized:boolean = false;
      let applicationRoles = token.customUserApplicationClaim.split(",");
      let hapRoles = token.role;
      let allRoles = applicationRoles.concat(hapRoles);

      for(let authRoleIndex = 0; authRoleIndex < authorizedRoles.length; authRoleIndex++) {
        authorized = authorized || this.userHasRole(authorizedRoles[authRoleIndex], allRoles);
      }
      return authorized;
    }));
  }

  private userHasRole(authorizedRole: string, userRoles: string[]): boolean {
    let hasRole:boolean = false;
    for (let userRoleIndex = 0; userRoleIndex < userRoles.length; userRoleIndex++) {
      hasRole = hasRole || userRoles[userRoleIndex].toLocaleLowerCase().trim() === authorizedRole.toLocaleLowerCase().trim();
    }
    return hasRole;
  }
}

